import createClient from 'openapi-fetch'
import type { paths } from './types.gen'
import { InteractionRequiredAuthError } from '@azure/msal-browser'
import { msalInstance } from '@/auth/msalInstance'

const apiScope = import.meta.env['VITE_API_SCOPE'] as string | undefined
const baseUrl = import.meta.env['VITE_API_BASE_URL'] as string

export const apiClient = createClient<paths>({ baseUrl })

apiClient.use({
  async onRequest({ request }) {
    if (!apiScope) return request

    const accounts = msalInstance.getAllAccounts()
    if (accounts.length === 0) return request

    try {
      const result = await msalInstance.acquireTokenSilent({
        scopes: [apiScope],
        account: accounts[0],
      })
      request.headers.set('Authorization', `Bearer ${result.accessToken}`)
    } catch (err) {
      if (err instanceof InteractionRequiredAuthError) {
        // Token expired or consent revoked — trigger a redirect to re-authenticate
        await msalInstance.acquireTokenRedirect({ scopes: [apiScope] })
      }
    }

    return request
  },
})
